// Site-wide schema objects included in the @graph on every page.
// Stable @id values so pages can reference them.

export const SITE_PERSON_SCHEMA = {
  "@type": "Person",
  "@id": "https://iamieshiadanielle.com/#person",
  name: "Ieshia Danielle",
  jobTitle: "Minister & Stewardship Coach",
  description:
    "Minister and stewardship coach helping women of faith move from burnout to becoming: breaking survival-mode cycles and stewarding the life God has given them.",
  url: "https://iamieshiadanielle.com",
  image:
    "https://vibe.filesafe.space/1787853701390843161/attachments/85108240-d531-4588-a52a-6b5fe2f30d03.jpg",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Gulfport",
    addressRegion: "MS",
    addressCountry: "US",
  },
  sameAs: [
    "https://youtube.com/@imieshiadanielle",
    "https://www.instagram.com/imieshiadanielle",
    "https://podcasts.apple.com/us/podcast/between-me-and-you-with-ieshia-danielle/id1736888997",
    "https://open.spotify.com/show/4P3vPSPtMLpDU1ERZ17pfVT",
  ],
};

export const SITE_ORGANIZATION_SCHEMA = {
  "@type": "Organization",
  "@id": "https://iamieshiadanielle.com/#organization",
  name: "Ieshia Danielle",
  url: "https://iamieshiadanielle.com",
  logo: "https://vibe.filesafe.space/1787853701390843161/assets/a5d05b54-0df1-474c-a727-ad33093a5f8e.png",
  founder: { "@id": "https://iamieshiadanielle.com/#person" },
};

export const SITE_WEBSITE_SCHEMA = {
  "@type": "WebSite",
  "@id": "https://iamieshiadanielle.com/#website",
  name: "Ieshia Danielle",
  url: "https://iamieshiadanielle.com",
  publisher: { "@id": "https://iamieshiadanielle.com/#organization" },
  inLanguage: "en-US",
};
